import React from "react";

import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import SbFooter from "../components/Footer/SbFooter";
import SportsBookAuth from "../container/SportsBook/Shared/SportBookAuth";

const HideFooter = ({ children }) => {
  const location = useLocation();
  const { isLoggedIn } = useSelector((state) => state.authentication);
  if (!isLoggedIn) return;
  return location.pathname.includes("/sports") ||
    location.pathname.includes("/sportsbookV2/") ? (
    <SportsBookAuth>
      <SbFooter />
    </SportsBookAuth>
  ) : (
    children
  );
};

export default HideFooter;
